import { c as _c } from "react/compiler-runtime";
import { BookingsFilterInterface } from 'modules/calendar/events/types/calendar-filter-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getFilterQueryString } from 'shared/utils/api/get-filter-query-string';
import { getPaginationAndFilterQueryString } from 'shared/utils/api/get-pagination-and-filter-query-string';
import { baseFetcher } from 'shared/utils/http-client';
import { squareBracketsToDots } from '../../utils/square-brackets-to-dots';
import { BOOKINGS_API } from '../api/bookings-api';
import { BookingStatusEnum } from '../constants';
import { BookingApiInterface } from '../types/bookings-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
interface UseBookingsInterface extends SwrPaginationInterface {
  filter: BookingsFilterInterface;
}
export function useBookings(t0) {
  const $ = _c(19);
  const {
    limit,
    pagination,
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const t2 = filter.status === BookingStatusEnum.All ? null : filter.status;
  const t3 = user?.timezone;
  let t4;
  if ($[1] !== filter.dateRange.endDate || $[2] !== filter.dateRange.startDate || $[3] !== filter.eventId || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      eventId: filter.eventId,
      status: t2,
      startDate: filter.dateRange.startDate,
      endDate: filter.dateRange.endDate,
      timezone: t3
    };
    $[1] = filter.dateRange.endDate;
    $[2] = filter.dateRange.startDate;
    $[3] = filter.eventId;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const bookingsFilter = t4;
  let t5;
  if ($[7] !== bookingsFilter || $[8] !== limit || $[9] !== pagination || $[10] !== user) {
    t5 = () => {
      if (user) {
        return [`${BOOKINGS_API}/list?${squareBracketsToDots(getPaginationAndFilterQueryString({
          limit,
          pagination,
          filter: bookingsFilter
        }))}`, RequestModuleEnum.Contacts, RequestModuleEnum.CalendarBookings];
      }
      return null;
    };
    $[7] = bookingsFilter;
    $[8] = limit;
    $[9] = pagination;
    $[10] = user;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const {
    data: bookings,
    mutate
  } = useControlledSwr(t5, fetcher);
  let t6;
  if ($[12] !== bookingsFilter || $[13] !== user) {
    t6 = () => {
      if (user) {
        return [`${BOOKINGS_API}/count?pagination.limit.${squareBracketsToDots(getFilterQueryString({
          filter: bookingsFilter
        }))}`, RequestModuleEnum.CalendarBookings];
      }
      return null;
    };
    $[12] = bookingsFilter;
    $[13] = user;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const {
    data: counter
  } = useControlledSwr(t6, baseFetcher);
  let t7;
  if ($[15] !== bookings || $[16] !== counter || $[17] !== mutate) {
    t7 = {
      bookings,
      mutate,
      counter
    };
    $[15] = bookings;
    $[16] = counter;
    $[17] = mutate;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}